import React, { useEffect, useState, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import CheckoutBlank from "../checkout/checkoutBlank";
import CheckoutSell from "../checkout/checkoutSell";
import CheckoutPayment from "../checkout/checkoutPayment";
import "./GiftCard.scss";
import DatePicker from "react-datepicker";
import { error, loading, Updateloading } from "../common/helpers/toastify";
import { useSelector } from "react-redux";
import NoOrdersYet from "../common/module/NoOrdersYet/NoOrdersYet";
import { _Api } from "../common/api/_call";
import { useTranslation } from "react-i18next";
import { toFormatPrice } from "../common/helpers/function";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { store } from "../../source/index";
import { Link, useNavigate } from "react-router-dom";
import giftCardOrderListImg from "../../assets/images/gift_cart_order.png";
import giftCardPlaceholderImg from "../../assets/images/giftcard_placeholder_img.png";
import printicon from "../../assets/images/print.png";

const GiftCard = () => {
  const { t } = useTranslation();
  let reduxdata = store.getState();
  let OrgSettings = reduxdata?.app?.posorganisation_settings;
  const { state } = useLocation();
  const location = useLocation();
  const order_id = location?.state?.state1?.order_id;
  const modalRef = useRef(null);
  const customer = useSelector((state) => state.app.customer);
  const saleperson = useSelector((state) => state.app.saleperson);
  const [activate,setActivate]=useState(true);
  const [cardname, setCardname] = useState("");
  const [amount, setAmount] = useState();
  const [UpdatedCart, setUpdatedCart] = useState();
  const [deletestatus, setdeletestatus] = useState(false);
  const [searchproductstatus, setsearchproductstatus] = useState();
  const [printUrls,setPrintUrls]=useState({printUrl:"",printURLticket:"",printURLencodeURLtcombined:""})
  const [print,setPrint]=useState()
  const pdfGeneratingRef = useRef(false);
  console.log(print,"ufls")
  const [allPrint,setAllPrint]=useState(false);
  const [invoicePrint,setInvoicePrint]=useState(false);
  const [ticketPrint,setTicketPrint]=useState(false);
  const [showcheckout, setShowcheckout] = useState(
    localStorage.getItem("showcheckout") || "blank"
  );
  const [showpayment, setShowpayment] = useState(false);
  const [remark, setRemark] = useState("");
  const [showRemarkSuggestion, setShowRemarkSuggestion] = useState(false);
  const remarkSuggestions = [
    "Promotional use",
    "Customer request",
    "Valid until 31 Jul 2027",
    "Customer appreciation",
  ];
  const [limit, setLimit] = useState(100);
  const [giftcard, setGiftcard] = useState("");
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const [TransactionDate, setTransactionDate] = useState(new Date());
  const [parmission, setParmission] = useState(0);
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const generateGiftCardNumber = (length = 12) => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"; // letters + numbers
    let result = "";
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };
  const [cardnumber, setCardnumber] = useState(generateGiftCardNumber(10));
  useEffect(() => {
    if (parmissiondatashow?.pos_coupon?.View)
      setParmission(parmissiondatashow?.pos_coupon?.Add);
  }, [parmissiondatashow]);
  const selectTransactionDate = (input) => {
    setTransactionDate(input);
  };
  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 },
  ];

  const getgiftcard = async (firstlimit) => {
    // if (!customer?.id) {
    //   error(t("Customer is Requried!!"));
    //   return;
    // }
    try {
      const postdata = {
        // customer_id: customer?.id,
        limit: firstlimit ? firstlimit : limit,
      };
      let res = await _Api(postdata, `api/v1/POS/giftCard/getGiftCard`);
      if (res.code === 200) {
        setGiftcard(res.data);
        if (state?.order_id && state?.order_edit && state?.order_type) {
          addtoexchangecart(
            state?.order_id,
            state?.order_edit,
            state?.order_type
          );
          setShowcheckout("sell");
        }
        setdeletestatus(false);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getgiftcardbyOrder = async (firstlimit, order_id) => {
    if (!customer?.id) {
      error(t("Customer is Requried!!"));
      return;
    }
    try {
      const postdata = {
        customer_id: customer?.id,
        limit: firstlimit ? firstlimit : limit,
        order_id: order_id,
      };
      let res = await _Api(postdata, `api/v1/POS/giftCard/getGiftCardsbyOrder`);
      if (res.code === 200) {
        setGiftcard(res.data);
        let printObj={
          printUrl:res?.printURL||null,
          printURLticket:res?.printURLticket||null,
          printURLencodeURLtcombined:res?.printURLencodeURLtcombined||null
        }
        setPrintUrls(printObj);
        setdeletestatus(false);
        return printObj;
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const creategiftcard = async () => {
    // if (!customer?.id) {
    //   error(t("Customer is Requried!!"));
    //   return;
    // }
    // if (!saleperson?.value) {
    //   error(t("SalePerson is Requried!!"));
    //   return;
    // }
    if (!cardname) {
      error(t("Gift card name is Requried!!"));
      return;
    }
    if (!cardnumber) {
      error(t("Gift card number is Requried!!"));
      return;
    }
    if (!TransactionDate) {
      error(t("Date is Requried!!"));
      return;
    }
    if (!amount) {
      error(t("Amount is Requried!!"));
      return;
    }
    try {
      setActivate(false)
      const postdata = {
        customer_id: customer?.id,
        sales_person_id: saleperson?.value,
        coupon_amount: parseFloat(amount),
        coupon_code: cardnumber,
        coupon_name: cardname,
        coupon_expire_date: TransactionDate,
        coupon_remark: remark,
      };
      let res = await _Api(postdata, `api/v1/POS/giftCard/createGiftCard`);
      if (res.code === 200) {
        getgiftcard();
        setsearchproductstatus(true);
        setShowcheckout("sell");
        if (modalRef.current) {
          modalRef.current.hide();
        }
        setActivate(true)
        setCardnumber(generateGiftCardNumber(10));
      } else {
        error(res?.message);
        setActivate(true)
      }
    } catch (err) {
      console.log(err, "err");
      setActivate(true)
    }
  };
  useEffect(() => {
    getgiftcard();
    // eslint-disable-next-line
  }, [customer?.id, deletestatus]);
  const addtoexchangecart = async (order_id, order_edit, order_type) => {
    try {
      const postdata = {
        order_id: order_id,
        order_type: order_type ? order_type : "gift_card_order",
        order_edit: order_edit,
      };
      let res = await _Api(postdata, `api/v1/POS/customOrder/getCartItems`);
      if (res.code === 200) {
        if (order_id || order_edit || order_type) {
          setUpdatedCart(res?.data);
          setShowcheckout("sell");
          setsearchproductstatus(true);
        }
      } else {
        error(t("This Product Already in cart!!"));
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    if (state?.order_id && state?.order_edit && state?.order_type) {
      addtoexchangecart(state?.order_id, state?.order_edit, state?.order_type);
    }
    // eslint-disable-next-line
  }, []);
  const handleCheckboxChange=(e,type)=>{
     if(type==="all"){
        setAllPrint(e.target.checked)
       setInvoicePrint(e.target.checked)
       setTicketPrint(e.target.checked)
      if(e.target.checked){
       setPrint("printURLencodeURLtcombined")
      }
      else{
       setPrint()
      }
     }
     else if(type==="invoice"){
      if(allPrint&&e.target.checked===false){
        return
      }
       setInvoicePrint(e.target.checked)
      if(e.target.checked){
        setPrint("printUrl")
      }
      else{
        setPrint()
      }
     }
     else if(type==="ticket"){
       if(allPrint&&e.target.checked===false){
        return
      }
       setTicketPrint(e.target.checked)
      if(e.target.checked){
       setPrint("printURLticket")
      }
      else{
       setPrint()
      }
     }
  }
  const handlePrint = async () => {
    if (printUrls?.[print]) {
      window.open(printUrls[print], "_blank");
      return;
    }
    if (pdfGeneratingRef.current) return;
    pdfGeneratingRef.current = true;
    const GetloadingID = loading();
    const failPrint = (message) => {
      Updateloading(t, GetloadingID, message || t("Something went wrong"), "error");
    };
    try {
      // The PDF prints the customer address from shipping_info.
      const details = await _Api({ order_id }, `api/v1/pos/customOrder/edit-details`);
      const shipping_info = details?.data?.billing_address
        ? details?.data
        : JSON.parse(localStorage.getItem("addcustomerdtaa"));
      const res = await _Api(
        { order_id, order_type: "gift_card_order", shipping_info },
        `api/v1/POS/customOrder/getOrderPdf`
      );
      if (res?.code !== 200) {
        failPrint(res?.message);
        return;
      }
      // getOrderPdf returns only the invoice link, so fetch all three links again.
      const urls = await getgiftcardbyOrder(limit, order_id);
      if (!urls?.[print]) {
        failPrint(t("PDF not available"));
        return;
      }
      // The browser can block a tab opened after a long API call.
      if (!window.open(urls[print], "_blank")) {
        failPrint(t("Please allow pop-ups to open the PDF"));
        return;
      }
      Updateloading(t, GetloadingID, t("PDF opened in new tab"));
    } catch (err) {
      console.log(err, "err");
      failPrint();
    } finally {
      pdfGeneratingRef.current = false;
    }
  };
  useEffect(() => {
    if (order_id) {
      getgiftcardbyOrder(limit, order_id);
    }
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (showcheckout) {
      localStorage.setItem("showcheckout", showcheckout);
    }
  }, [showcheckout]);
  useEffect(() => {
    modalRef.current = new window.bootstrap.Modal(
      document.getElementById("giftcardADDModal")
    );
  }, []);
  return (
    <>
      <div className="main-body">
        <div className="main-body-row">
          <div className="main-body-row-left-col p-0">
            <div className="gift-card-page">
              <div className="customer-inner-tophead">
                <h4 className="main-heading">{t("Gift Card")}</h4>
                <div className="customer-inner-tophead-right">
                  <div className="customer-inner-tophead-right-custom">
                    {!order_id ? (
                      <button
                        className={
                          parmission ? "cst-btn btn img-btn-hover" : "d-none"
                        }
                        data-bs-toggle="modal"
                        data-bs-target="#giftcardADDModal"
                        onClick={() => {
                          setCardname("");
                          setAmount("");
                          setRemark("");
                        }}
                      >
                        <img
                          src={base_assets + "images/icons/adplus.png"}
                          className="img-btn-hover-img-1"
                          alt="filter"
                        />
                        <img
                          src={base_assets + "images/icons/adplus-w.png"}
                          className="img-btn-hover-img-2"
                          alt="filter"
                        />
                        {t("Gift Card")}
                      </button>
                    ) : (
                      ""
                    )}
                    <div
                      className="modal fade giftcard-modal"
                      id="giftcardADDModal"
                      tabIndex="-1"
                      aria-labelledby="giftcardADDModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-dialog-centered giftcard-modal-popupbox">
                        <div className="modal-content giftcard-modal-popupbox-outer">
                          <div className="giftcard-modal-popupbox-content">
                            <div className="giftcard-modal-popupbox-content-header">
                              <h1 className="giftcard-modal-popupbox-content-heading">
                                {t("Create Gift card")}
                              </h1>
                              <div className="giftcard-modal-popupbox-content-close">
                                <img
                                  className="giftcard-modal-popupbox-content-close-btn"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                  src={base_assets + "images/pos/close-btn.png"}
                                  onClick={()=>setCardnumber(generateGiftCardNumber(10))}
                                  alt=""
                                ></img>
                              </div>
                            </div>
                            <div className="giftcard-modal-popupbox-content-inner">
                              <div className="placeholder-up-input form-floating">
                                <input
                                  value={cardname}
                                  type="text"
                                  className="form-control placeholder-up-input-field giftcard-modal-popupbox-content-inner-from"
                                  placeholder="Gift card name *"
                                  onChange={(e) => setCardname(e.target.value)}
                                  aria-label="Gift card name *"
                                />
                                <label className="placeholder-up-input-label">
                                  {t("Gift card name")} <sup>*</sup>
                                </label>
                              </div>
                              <div className="placeholder-up-input form-floating">
                                <input
                                  value={cardnumber}
                                  type="text"
                                  className=" form-control placeholder-up-input-field giftcard-modal-popupbox-content-inner-from"
                                  placeholder="Gift card number *"
                                  aria-label="Gift card number *"
                                  onChange={(e) =>
                                    setCardnumber(e.target.value)
                                  }
                                />
                                <label className="placeholder-up-input-label">
                                  {t("Gift card number")} <sup>*</sup>
                                </label>
                                <button
                                  type="button"
                                  onClick={()=>setCardnumber(generateGiftCardNumber(10))}
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer",
                                  }}
                                  title="Generate Random Number"
                                >
                                  🎲
                                </button>
                              </div>
                              <div className="giftcard-modal-popupbox-content-inner-from-date-remark">
                                <div className="giftcard-modal-popupbox-content-inner-from-date">
                                  <div className=" placeholder-up-input-date date ">
                                    <DatePicker
                                      className="placeholder-up-input-field popup-date"
                                      selected={TransactionDate}
                                      onChange={selectTransactionDate}
                                      name="TransactionDate"
                                      dateFormat={OrgSettings?.date_picker}
                                      autoComplete="none"
                                    />

                                    <img
                                      className="placeholder-up-input-field-calender"
                                      src={
                                        base_assets +
                                        "images/icons/calendar-green.svg"
                                      }
                                      alt=""
                                    />
                                    <label className="placeholder-up-input-label">
                                      {t("Date")}
                                    </label>
                                  </div>
                                  <div className="placeholder-up-input form-floating">
                                    <input
                                      type="number"
                                      value={amount}
                                      className="popup-amount form-control placeholder-up-input-field"
                                      placeholder="Amount *"
                                      aria-label="Amount *"
                                      onChange={(e) =>
                                        setAmount(e.target.value)
                                      }
                                    />
                                    <label className="placeholder-up-input-label">
                                      {t("Amount")} <sup>*</sup>
                                    </label>
                                  </div>
                                </div>
                                <div className="giftcard-modal-popupbox-content-inner-remark-confirm-btn">
                                  <div className="giftcard-modal-popupbox-content-inner-remark">
                                    <span>{t("Remark")} :</span>
                                    <input
                                      value={remark}
                                      type="text"
                                      className="giftcard-modal-popupbox-content-inner-remark-border"
                                      onChange={(e) =>
                                        setRemark(e.target.value)
                                      }
                                      onFocus={() =>
                                        setShowRemarkSuggestion(true)
                                      }
                                      onBlur={() =>
                                        setShowRemarkSuggestion(false)
                                      }
                                    />
                                    {showRemarkSuggestion ? (
                                      <div className="giftcard-modal-popupbox-content-inner-remark-suggestion">
                                        <span className="giftcard-modal-popupbox-content-inner-remark-suggestion-title">
                                          {t("Suggestion")}
                                        </span>
                                        {remarkSuggestions.map(
                                          (suggestion, sIndex) => (
                                            <span
                                              key={sIndex}
                                              className="giftcard-modal-popupbox-content-inner-remark-suggestion-item"
                                              onMouseDown={(e) =>
                                                e.preventDefault()
                                              }
                                              onClick={() => {
                                                setRemark(suggestion);
                                                setShowRemarkSuggestion(false);
                                              }}
                                            >
                                              {suggestion}
                                            </span>
                                          )
                                        )}
                                      </div>
                                    ) : null}
                                  </div>
                                  <div className="giftcard-modal-popupbox-content-inner-confirm-btn-outer">
                                    <button
                                      className="giftcard-modal-popupbox-content-inner-confirm-btn-inner"
                                      onClick={(e) =>
                                        creategiftcard(e.target.value)
                                      }
                                      disabled={!activate}
                                    >
                                      {t("Confirm")}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Link to="/app/pos/giftCardOrderList">
                    <img
                      className="custom-order-img"
                      // src={
                      //   base_assets + "images/pos/icons/custom-order-icon.png"
                      // }
                      src={giftCardOrderListImg}
                      alt="giftCardOrderImg"
                    />
                    <span className="com-btn custom-tooltip-text">
                      {t("Gift Card Order")}
                    </span>
                  </Link>
                </div>
              </div>
              <div className="search-custom giftcard-search-custom d-flex align-items-center">
                <span className="title">{t("Show")} :</span>
                <div style={{ minWidth: "4.2vw", width: "fit-content" }}>
                  <Select
                    className="select p-0 main-content-wrapper-body-top-status-bar-select-num mx-2"
                    options={selectOptions}
                    value={{ label: limit, value: limit }}
                    onChange={(e) => {
                      setLimit(e.value);
                      getgiftcard(e.value);
                    }}
                    isSearchable={false}
                  />
                </div>
                <div className="customer-inner-data-payment-table-top-bar-right placeholder-up-input-date date ms-auto me-2">
                  <DatePicker
                    className="placeholder-up-input-field"
                    selected={TransactionDate}
                    onChange={(input) => setTransactionDate(input)}
                    name="TransactionDate"
                    dateFormat={OrgSettings?.date_picker}
                    autoComplete="none"
                  />
                  <img
                    className="placeholder-up-input-field-calender"
                    src={base_assets + "images/icons/calendar-green.svg"}
                    alt=""
                  />
                </div>
                <div style={{ marginRight: "0.5vw" }}>
                  {order_id ? (
                    <img
                      src={printicon}
                      alt="printpdf"
                      data-bs-toggle="modal"
                      data-bs-target="#printModal"
                    />
                  ) : (
                    ""
                  )}
                  <div
                    className="modal fade giftcard-modal"
                    id="printModal"
                    tabIndex="-1"
                    aria-labelledby="printModalLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-dialog-centered">
                      <div
                        className="modal-content"
                        style={{ borderRadius: "0", width: "22vw" }}
                      >
                        <div
                          className="modal-header"
                          style={{
                            borderBottom: "none",
                            margin: "1vw",
                            padding: "0",
                          }}
                        >
                          <h5
                            className="modal-title fw-bold d-flex"
                            id="printModalLabel"
                          >
                            {t("Print Document")}
                          </h5>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => {}}
                          />
                        </div>
                        <div
                          className="modal-body"
                          style={{ margin: "0 1vw", padding: "0" }}
                        >
                          <h6
                            className="modal-title d-flex"
                            id="printModalLabel"
                            style={{
                              color: "#2A2A2A",
                              fontSize: "14px",
                              fontWeight: "600",
                            }}
                          >
                            {t("Select Document to Print")}
                          </h6>
                          <div
                            className={"com-check"}
                            style={{
                              marginTop: "1vw",
                              display: "flex",
                              alignItems: "center",
                              gap: "1vw",
                            }}
                          >
                            <input
                              id="All"
                              type="checkbox"
                              className="reserve_item pos_reservetablehead"
                              name="customchack"
                              checked={allPrint}
                              onChange={(e) => handleCheckboxChange(e, "all")}
                            />
                            <label
                              htmlFor="All"
                              className="com-check-label"
                            ></label>
                            <span style={{ color: "#2A2A2A" }}>All</span>
                          </div>
                          <div
                            className={"com-check"}
                            style={{
                              marginTop: "1vw",
                              display: "flex",
                              alignItems: "center",
                              gap: "1vw",
                            }}
                          >
                            <input
                              id="Invoice"
                              type="checkbox"
                              className="reserve_item pos_reservetablehead"
                              name="customchack"
                              checked={invoicePrint}
                              onChange={(e) =>
                                handleCheckboxChange(e, "invoice")
                              }
                            />
                            <label
                              htmlFor="Invoice"
                              className="com-check-label"
                            ></label>
                            <span style={{ color: "#2A2A2A" }}>Invoice</span>
                          </div>
                          <div
                            className={"com-check"}
                            style={{
                              marginTop: "1vw",
                              display: "flex",
                              alignItems: "center",
                              gap: "1vw",
                            }}
                          >
                            <input
                              id="Gift-Card"
                              type="checkbox"
                              className="reserve_item pos_reservetablehead"
                              name="customchack"
                              checked={ticketPrint}
                              onChange={(e) =>
                                handleCheckboxChange(e, "ticket")
                              }
                            />
                            <label
                              htmlFor="Gift-Card"
                              className="com-check-label"
                            ></label>
                            <span style={{ color: "#2A2A2A" }}>Gift Card</span>
                          </div>
                        </div>
                        <div
                          style={{
                            border: "1px solid #E3E3E3",
                            marginTop: "30px",
                          }}
                        ></div>
                        <div className="modal-footer justify-content-end">
                          <button
                            type="button"
                            className="btn btn-outline-secondary btn-cancel"
                            data-bs-dismiss="modal"
                            style={{
                              borderRadius: "3px",
                              height: "3.6vh",
                              minWidth: "4.7vw",
                              borderColor: "#E3E3E3",
                            }}
                          >
                            {t("Cancel")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary btn-submit"
                            data-bs-dismiss="modal"
                            style={{
                              borderRadius: "3px",
                              backgroundColor: "#52CBC4",
                              height: "3.6vh",
                              minWidth: "4.7vw",
                              borderColor: "#fff",
                            }}
                            disabled={!print}
                            onClick={handlePrint}
                          >
                            {t("Print")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="main-giftcard position-relative">
                <div className="main-giftcard-inner">
                  {giftcard?.length ? (
                    giftcard.map((result, key) => {
                      return (
                        <div className="gificard" key={key}>
                          <div className="gificard-inner-right">
                            <div className="gificard-inner-right-inner">
                              <div className="gificard-inner-right-inner-head">
                                <span className="gificard-inner-right-inner-heading">
                                  {result?.card_no}
                                </span>
                                <span className="gificard-inner-right-inner-text">
                                  {result?.expire_date}
                                </span>
                              </div>
                              <div className="gificard-inner-right-inner-scanner">
                                <img
                                  className="gificard-inner-right-inner-scanner-qrcode"
                                  src={result?.qr_code}
                                  alt=""
                                />
                                <img
                                  className="gificard-inner-right-inner-scanner-barcode"
                                  src={result?.barcode}
                                  alt=""
                                />
                              </div>
                            </div>
                            <img
                              className="gificard-inner-right-triangle"
                              src={
                                base_assets +
                                "images/pos/icons/triangle-shape.png"
                              }
                              alt=""
                            />
                            <img
                              className="gificard-inner-right-triangle gificard-inner-right-triangle-bottom"
                              src={
                                base_assets +
                                "images/pos/icons/triangle-shape.png"
                              }
                              alt=""
                            />
                          </div>
                          <div className="gificard-inner-left">
                            <div className="gificard-inner-left-inner">
                              <span className="gificard-inner-left-inner-heading">
                                {result?.name}
                              </span>
                              <span className="gificard-inner-left-inner-rupess">
                                {toFormatPrice(result?.amount, {
                                  addSymbol: true,
                                })}
                              </span>
                              {result?.remark ? (
                                <div className="gificard-inner-left-inner-text">
                                  <label className="gificard-inner-left-inner-text-remark">
                                    {t("Remark")}:
                                  </label>
                                  <label>{result?.remark}</label>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    // <NoOrdersYet />
                    <img
                      src={giftCardPlaceholderImg}
                      alt="giftCardPlaceholderImg"
                      className="gift-cardplaceholderimg"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="main-body-row-right-col">
            {showcheckout === "sell" ? (
              <CheckoutSell
                setShowcheckout={setShowcheckout}
                setdeletestatus={setdeletestatus}
                setUpdatedCart={setUpdatedCart}
                UpdatedCart={UpdatedCart}
                setShowpayment={setShowpayment}
                showpayment={showpayment}
                searchproductstatus={searchproductstatus}
                setsearchproductstatus={setsearchproductstatus}
                ordertype={"gift_card_order"}
                order_edit={state?.order_edit}
                order_type={state?.order_type}
                order_id={state?.order_id}
              />
            ) : showcheckout === "payment" ? (
              <CheckoutPayment
                UpdatedCart={UpdatedCart}
                setShowcheckout={setShowcheckout}
                order_edit={state?.order_edit}
                order_type={state?.order_type}
                order_id={state?.order_id}
              />
            ) : (
              <CheckoutBlank />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default GiftCard;
